import { browserHistory } from 'react-router'

export const USER_LOGGED_IN = 'USER_LOGGED_IN'
function userLoggedIn(user) {
    return {
        type: USER_LOGGED_IN,
        payload: user
    }
}

export function loginUser(keystore) {

    return function(dispatch) {
      
        dispatch(userLoggedIn({'keystore' : keystore, 'addressBalance':'N-N'}))

        let currentLocation = browserHistory.getCurrentLocation()
        if ('redirect' in currentLocation.query){
            return browserHistory.push(decodeURIComponent(currentLocation.query.redirect))
        }
        return browserHistory.push('/my-wallet')	
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/LoginAction.js